// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__JK3uY","insightsList":"newBusinessInsightsMenu_insightsList__3nUHr","active":"newBusinessInsightsMenu_active__O23Hs"};